import { useEffect, useState } from 'react';
import { EDITOR_FONT_MANIFEST } from '../fonts/fontProvider';
import { ensureAllV46FontsReady } from '../runtime/fontRuntime';

export interface FontReadiness {
  readonly status: 'loading' | 'ready' | 'error';
  readonly missing: readonly string[];
}

export function useFontReadiness(enabled = true): FontReadiness {
  const [state, setState] = useState<FontReadiness>(
    enabled ? { status: 'loading', missing: [] } : { status: 'ready', missing: [] },
  );

  useEffect(() => {
    if (!enabled) {
      setState({ status: 'ready', missing: [] });
      return;
    }
    let cancelled = false;
    const timeout = new Promise<never>((_, reject) => {
      window.setTimeout(() => reject(new Error('Tiempo de carga agotado')), 8_000);
    });
    const loading = Promise.resolve()
      .then(() => ensureAllV46FontsReady())
      .then(() => [] as string[]);

    Promise.race([loading, timeout])
      .then((missing) => {
        if (cancelled) return;
        const filtered = missing as string[];
        setState(filtered.length === 0 ? { status: 'ready', missing: [] } : { status: 'error', missing: filtered });
      })
      .catch(() => {
        if (!cancelled) {
          const missing = EDITOR_FONT_MANIFEST.map(({ family }) => family);
          setState({ status: 'error', missing });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return state;
}
